import style from "./NewLocation.module.scss"
import Frame from "../IU/Frame/Frame";
import LocationForm from "./LocationForm";
import {useState} from "react";
import {ValidateString} from "../../validators";
import {useMutation, useQuery} from "@apollo/client";
import {DELETE_CITY, UPDATE_CITY} from "../../graphql/mutations/city";
import {updateCity, updateCityVariables} from "../../graphql/mutations/__generated__/updateCity";
import {MySwal, Toast} from "../Deals/DealFormAffiliate";
import {useNavigate, useParams} from "react-router-dom";
import {GET_ALL_CITIES, GET_CITY} from "../../graphql/queries/city";
import {getCity, getCityVariables} from "../../graphql/queries/__generated__/getCity";
import Swal from "sweetalert2";
import {LIST_TRIP} from "../../graphql/queries/trip";
import {LIMIT_PAGINATION} from "../IU/Pagination/Pagination";
import {deleteCity, deleteCityVariables} from "../../graphql/mutations/__generated__/deleteCity";

interface IFormData {
    [key: string]: any;
}
const Location = () => {
    const navigate = useNavigate()
    const params = useParams();
    const [errors, setErrors] = useState<any>({});
    const {loading, error, data} = useQuery<getCity, getCityVariables>(GET_CITY, { variables: { id: params?.id! }, fetchPolicy: "network-only"})
    const [updateCity]= useMutation<updateCity, updateCityVariables>(UPDATE_CITY)
    const [deleteCity]= useMutation<deleteCity, deleteCityVariables>(DELETE_CITY)

    const validateForm = (data: IFormData): boolean => {

        const errors: any = {};


        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return false;
        }


        for (const field in data) {
            const val = data[field];
            const isOk = ValidateString(val, 1);
            if (!isOk) {
                errors[field] = `${field} est invalide.`;
            }
        }

        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return false;
        }
        setErrors({});
        return true;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const state = e.target["state"]?.value;
        const country = e.target["country"]?.value;
        const city = e.target["city"]?.value;
        const lat = e.target["lat"]?.value;
        const lon = e.target["lon"]?.value;

        const formData: IFormData = {
            stateName: state?.length > 0 ? state : null,
            countryName: country?.length > 0 ? country : null,
            name: city?.length > 0 ? city : null,
            latitude: lat?.length > 0 ? lat : null,
            longitude: lon?.length > 0 ? lon : null,
        };
        const isOk = validateForm(formData);
        if (!isOk) {
            return;
        }

        updateData(formData, data?.city?.id)

    }

    const updateData = async (data, id) => {
        try{
            await updateCity({
                variables: {
                    city: data,
                    id: id
                }
            })
            await Toast.fire({
                icon: 'success',
                title: 'Ville mise à jour'
            })
            navigate('/locations')
        }catch (e) {
            console.log(e)
        }
    }

    const deleteLocationHandler = (id) => {
        Swal.fire({

            title: 'Voulez-vous vraiment supprimé cette ville ?',
            text: "Il sera impossible d'annuler cette action!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD4646',
            cancelButtonColor: '#2D2C6C',
            confirmButtonText: 'Supprimer !',
            cancelButtonText: 'Annuler !',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    deleteCity({
                        variables: {
                            id: id
                        }, refetchQueries: [{
                            query: GET_ALL_CITIES, variables:{id: 0, limit: LIMIT_PAGINATION},fetchPolicy: "network-only"}]
                    })
                    Swal.fire(
                        'Supprimé!',
                        'La ville a bien été supprimé.',
                        'success'
                    )
                    navigate('/locations')
                }
                catch (e:any) {
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong: \n '+ e.message,
                    })
                }

            }
        })

    }

    return(
        <Frame borderRadius={"20px"} boxShadow={"0px 5px 19px 0px #DCDCDC"}>
            <div className={style['container--frame']}>

                <div className={style['header']}>
                    Mettre à jour une ville
                    <div className={style["line"]}></div>
                </div>
            </div>
            <LocationForm handleSubmit={handleSubmit} formErrors={errors} location={data?.city} deleteLocationHandler={deleteLocationHandler}/>
        </Frame>

    )
}

export default Location
